import React, { useState, useEffect, useContext, useRef } from 'react';
import _, { debounce } from 'lodash';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import List from '@shared/component/List';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Multiselect from 'multiselect-react-dropdown';
import DropDown from '@shared/component/DropDown';
import CheckValidator from '@shared/checkValidator';
import MultiSelect from '@shared/component/MultiSelect';
import Lists from '@shared/component/Lists';
import { ActionValues, actionsPermissionValidator } from '@utils/static/commonUtils';

export function Items() {
    const [errors, setError] = useState<any>({
        itemsName: {
            required: true,
            error: true,
            message: 'Please enter name',
            pattern: /^[A-Za-z][A-Za-z0-9\s.&]*$/,
            maxLength: 50,
        },
        categoryId: {
            required: true,
            error: true,
            message: 'Please select category',
        },
        itemType: {
            required: true,
            error: true,
            message: 'Please select type',
        },
    });
    const listRef: any = useRef(null);
    const { setLoader } = useContext(AuthContext);
    const [categories, setCategories] = useState([]);
    const [items, setitems] = useState([]);
    const [id, setId] = useState(null);
    const [itemsName, setitemsName] = useState('');
    const [categoryId, setCategoriesId] = useState('');
    const [itemType, setItemType] = useState('');
    const [userIds, setUserIds] = useState([1]);
    const [deleteshow, setDeleteShow] = useState(false);
    const [search, setSearch] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [formData, setFormData] = useState<any>({ name: null, itemType: null, categoryId: null, userIds: [] });
    const [vendor, setVendor] = useState([]);
    const [vendorFilter, setvendorFilter] = useState([]);
    const [showHideModel, setShowHideModel] = useState(false);
    const [edit, setEdit] = useState(false);
    const [itemTypeArr, setItemTypeArr] = useState([
        { key: 'mass', value: 'Mass' },
        { key: 'volume', value: 'Volume' },
        { key: 'length', value: 'Length' },
        { key: 'energy', value: 'Energy' },
        { key: 'pieces', value: 'Pieces' },
    ]);
    const [columns, setColumns] = useState({
        id: 'ID',
        name: 'Items',
        'category.name': 'Category',
        type: 'Type',
        status: 'Status',
        // action: 'Action',
        ...(actionsPermissionValidator(location.pathname, ActionValues.Edit) ? { action: 'Action' } : null),
    });
    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
        } catch (error) {}
    };

    const getCategory = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`category/all/nolimit`, true, false);
            setCategories(data.data.data);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const data = await APIService.getAll(
                `items/search/get?page=${page}&order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );
            setitems(data.data.data);
            setRecordCount(data?.data?.count || 0);
        } catch (err) {
            setLoader(false);
        }
    };

    const getitems = async (page: any = 1) => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`items/all/get?page=${page}&sort=createdAt`, true, false);
            setitems(data.data.data);
            setRecordCount(data?.data?.count || 0);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getitems();
        getCategory();
        getVendor();
    }, []);

    const additems = async () => {
        try {
            const isValid = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);
            // return;
            if (isValid) {
                if (formData?.categoryId == null || formData?.categoryId == '') {
                    Notify('error', 'Please select category');
                } else if (formData?.itemType == null || formData?.itemType == '') {
                    Notify('error', 'Please select item type');
                } else {
                    const data = {
                        name: formData?.itemsName,
                        type: formData?.itemType,
                        categoryId: formData?.categoryId,
                        userIds: JSON.stringify(formData?.userIds),
                    };
                    setLoader(true);
                    const updateddata = await APIService.post('items', data, true, true);
                    setLoader(false);
                    if (updateddata.status === 200) {
                        Notify('success', 'Item added successfully');
                        setFormData({});
                        setEdit(false);
                        handelModel(false);
                        getitems();
                        listRef.current.clearSearchBox();
                    }
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };
    const updateStatus = async (item: any, status: any, id: any, page: any, search: any) => {
        try {
            const data = {
                status: status,
            };
            setLoader(true);
            const updateddata = await APIService.update('items/status', item?.id, data, true, true);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', 'Item status updated');
                searchItem(search.trim(), page);
                // getitems(page);
            }
        } catch (err) {
            setLoader(false);
        }
    };
    const getVendor = async () => {
        try {
            // const data = await APIService.getAll('user/get/allOtherAppUser?type=active&sort=createdAt', true, false);
            const data = await APIService.getAll(
                'user/public/get/allOtherAppUser?type=active&sort=createdAt',
                true,
                false,
            );

            setVendor(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const updateitems = async () => {
        try {
            setIsSubmit(true);
            const isValid = await CheckValidator(errors, formData);
            if (isValid) {
                if (formData?.categoryId == null || formData?.categoryId == '') {
                    Notify('error', 'Please select category');
                } else if (formData?.itemType == null || formData?.itemType == '') {
                    Notify('error', 'Please select item type');
                } else {
                    const data = {
                        name: formData?.itemsName,
                        type: formData?.itemType,
                        categoryId: formData?.categoryId,
                        userIds: JSON.stringify(formData?.userIds),
                    };
                    setLoader(true);
                    const updateddata = await APIService.update('items', id, data, true, true);
                    setLoader(false);
                    if (updateddata.status === 200) {
                        Notify('success', 'Item updated successfully');

                        setEdit(false);
                        handelModel(false);
                        getitems();
                        listRef.current.clearSearchBox(true);
                    }
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };
    const getitemsById = async (id: any) => {
        try {
            setLoader(true);
            const updateddata = await APIService.getById('items/get', id, true, false);
            setLoader(false);
            if (updateddata.status === 200) {
                const iData = updateddata.data.getAllData;
                setFormData({
                    ['itemsName']: iData.name,
                    ['itemType']: iData.type,
                    ['categoryId']: iData.category.id,
                    ['userIds']: iData.app_users,
                    categoryData: { label: iData?.category?.name || '', value: iData?.category?.id || 0 },
                });
                setEdit(true);
                handelModel(true);
                setId(updateddata.data.getAllData.id);
            }
        } catch (err) {
            setLoader(false);
        }
    };
    const handlereset = () => {
        setEdit(false);
        setFormData({
            ['itemsName']: null,
            ['itemType']: null,
            ['categoryId']: null,
            ['userIds']: [],
        });
        setVendor([]);
        handelModel(false);
    };
    const getDeleteIds = async (ids: any) => {
        try {
            setLoader(true);
            const data = {
                ids: JSON.stringify(ids),
            };
            const updateddata = await APIService.update('items', '', data, true, false);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', 'Item deleted successfully');
                setLoader(false);
                getitems();
            }
        } catch (err) {
            setLoader(false);
        }
    };
    const getValue = (e: any) => {
        try {
            const data = { ...formData, ...e };
            setFormData(data);
        } catch (error) {}
    };
    const handlevendor = (data: any) => {
        const d = data.map((i: any) => {
            return { id: i.id, name: i.name };
        });
        setFormData({ ...formData, ['userIds']: d });
    };

    const getMultiSelectValue = (e: any) => {
        try {
            getValue({ userIds: e });
            // errors['userIds']['error'] = false;
            // setError(errors)
        } catch (error) {}
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>Items</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    {/* <List
                        ref={listRef}
                        headTitles={['ID', 'Items', 'Category', 'Type']}
                        searchItem={searchItem}
                        tab={'name...'}
                        list={items}
                        updateStatus={updateStatus}
                        getById={getitemsById}
                        getDeleteIds={getDeleteIds}
                        addUpdateText="Items"
                        type={'item'}
                        handelModel={(e: boolean) => handelModel(e)}
                        recordCount={recordCount}
                        callPagination={getitems}
                    /> */}
                    <Lists
                        ref={listRef}
                        headers={columns}
                        data={items}
                        type={'add+delete'}
                        addUpdateText="Items"
                        updateStatus={updateStatus}
                        searchItem={searchItem}
                        getById={getitemsById}
                        getDeleteIds={getDeleteIds}
                        handelModel={(e: boolean) => handelModel(e)}
                        recordCount={recordCount}
                        callPagination={getitems}
                    />
                </div>
                {showHideModel && (
                    <Modal
                        // scrollable={true}
                        show={true}
                        onHide={() => handlereset()}
                        backdrop="static"
                        size="lg"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title> {edit ? 'Edit Items' : 'Add Items'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="material_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="field_box field_no_margin">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Item Name',
                                                            name: 'itemsName',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="itemsName"
                                                        isSubmit={isSubmit}
                                                        value={formData?.itemsName}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.itemsName.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <MultiSelect
                                                    isSingle={true}
                                                    options={categories}
                                                    placeholder={'Select Category*'}
                                                    getMultiSelectValue={(e: any) => {
                                                        // getValue(e);

                                                        if (e?.value) {
                                                            // getValue({ categoryId: e.value });
                                                            formData['categoryId'] = e.value;
                                                            setFormData(formData);
                                                            errors['categoryId']['error'] = false;
                                                            setError(errors);
                                                            const vendorList = vendor.filter(
                                                                i => i.categoryId == parseInt(e.value),
                                                            );
                                                            // console.log('vendorList', vendorList)
                                                            setvendorFilter(vendorList);
                                                        } else {
                                                            errors['categoryId']['error'] = true;
                                                            setError(errors);
                                                        }
                                                    }}
                                                    displayName="name"
                                                    displayValue="id"
                                                    isClearable={edit ? false : true}
                                                    setSelectedValues={formData?.categoryData || null}
                                                />

                                                {errors?.categoryId?.required &&
                                                    errors?.categoryId?.error &&
                                                    isSubmit && (
                                                        <div className="text-danger ft-12">
                                                            {' '}
                                                            {errors?.categoryId.message}
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                        <br />
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <DropDown
                                                    data={{
                                                        placeholder: 'Select Type',
                                                        name: 'type',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="itemType"
                                                    displayName={'value'}
                                                    optionValue={'key'}
                                                    optionKey={'key'}
                                                    isSubmit={isSubmit}
                                                    value={formData?.itemType}
                                                    options={itemTypeArr}
                                                    setValue={(e: any) => {
                                                        getValue(e);
                                                    }}
                                                    errorMsg={errors?.itemType.message}
                                                    inputProps={errors}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <MultiSelect
                                                        options={vendorFilter}
                                                        placeholder={'Select User'}
                                                        getMultiSelectValue={getMultiSelectValue}
                                                        displayName="name"
                                                        displayValue="id"
                                                        notSelectDefault={true}
                                                        setSelectedValues={formData.userIds || null}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                className="btn dark_btn custom_btn"
                                onClick={edit ? updateitems : additems}
                            >
                                {edit ? 'Update' : 'Add'}
                            </Button>
                            <Button
                                variant="default"
                                className="btn custom_btn border_btn with_icon"
                                onClick={() => {
                                    handlereset();
                                }}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </>
    );
}
